import type { UserDraft } from '../../_shared/domain/user-draft.model';

/**
 * Add-user draft: extends the shared identity draft with the licence picked on
 * creation (Edit shows licence read-only, so this field is Add-only). Pure and
 * serialisable. `''` = no licence chosen yet (the select's pristine value).
 */
export interface AddUserDraft extends UserDraft {
  licenceId: string;
}

/** A pristine Add draft. */
export const emptyAddDraft: AddUserDraft = {
  firstName: '',
  lastName: '',
  email: '',
  linkedinUrl: '',
  licenceId: '',
};

/** Field-keyed validation messages produced by `validateAddDraft`. */
export type AddValidationErrors = Partial<Record<keyof AddUserDraft, string>>;
